import copy from 'copy-to-clipboard'
import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useNavigate } from 'react-router'
import { Element } from '../../../common/html/element'
import { Input } from '../../../common/html/input'
import { PopupAction } from '../../../common/popup/PopupAction'
import { formatCurrencyFollowLocale, formatText } from '../../../helpers/value'
import { COMPONENTS } from '../../../routers/constants'
import { ORDER_TYPE } from '../../../userManagement/subscriptionPayment/common/constants'
import { CURRENCY } from '../../../utils/currency'
import { TYPE_TRANSFER } from '../../constant'
import { selectCodeBankTransfer } from '../../store/slice'
import classes from './index.module.scss'

export const TransferInformationPopup = ({
  isShow,
  onClose,
  orderId,
  orderType,
  type = TYPE_TRANSFER.VND,
}) => {
  const navigate = useNavigate()
  const data = useSelector(selectCodeBankTransfer)
  const locale = useSelector((state) => state.i18n.locale)

  const onClickIcon = (text) => (copy(text) ? copy(text) : null)

  const handleClosePopup = () => {
    onClose(false)
    if (data?.snpOrderIds.length === 1) {
      navigate(
        COMPONENTS.userManagement.components.subscriptionPayment.components
          .requestDetail.route +
          '?requestId=' +
          data.snpOrderIds[0],
      )
      return
    }
    if (orderId) {
      if (orderType === ORDER_TYPE.REPORT) {
        navigate(
          COMPONENTS.userManagement.components.subscriptionPayment.components
            .orderDetail.route +
            '?orderId=' +
            orderId,
        )
      } else {
        navigate(
          COMPONENTS.userManagement.components.subscriptionPayment.components
            .requestDetail.route +
            '?requestId=' +
            orderId,
        )
      }
      return
    }
  }

  const renderContentVND = () => {
    return (
      <>
        <div className="fstItalic">
          <Translate value="cartAndOrders.transferInformation.textNote" />
        </div>
        <div className="dFlex pt1">
          <div style={{ width: 340 }}>
            <div className={classes.input}>
              <Input
                isShowLabel
                isShowIcon={false}
                placeHolder="cartAndOrders.transferInformation.bank"
                disabled
                value={formatText(data?.bank)}
                style={{ color: '#B5B5B5' }}
              />
            </div>

            <div className={classes.input}>
              <Input
                isShowLabel
                isShowIcon
                placeHolder="cartAndOrders.transferInformation.accountNumber"
                value={formatText(data?.accountNumber)}
                disabled
                onClickIcon={onClickIcon}
                classIcon="icon-content-coppy"
                styleIcon={{ color: '#0553A5', fontSize: 16 }}
                style={{ color: '#9C9C9C' }}
              />
            </div>
            <div className={classes.input}>
              <Input
                isShowLabel
                isShowIcon
                placeHolder="cartAndOrders.transferInformation.amount"
                value={formatCurrencyFollowLocale(
                  data?.amount,
                  CURRENCY.VND,
                  locale,
                )}
                disabled
                onClickIcon={() => onClickIcon(data?.amount)}
                classIcon="icon-content-coppy"
                style={{ color: '#B5B5B5' }}
                styleIcon={{ color: '#0553A5', fontSize: 16 }}
              />
            </div>
            <div className={classes.input}>
              <Input
                isShowLabel
                isShowIcon
                placeHolder="cartAndOrders.transferInformation.message"
                value={formatText(data?.message)}
                onClickIcon={onClickIcon}
                disabled
                classIcon="icon-content-coppy"
                styleIcon={{ color: '#0553A5', fontSize: 16 }}
                style={{ color: '#9C9C9C' }}
              />
            </div>
          </div>
          <div
            className={`${classes.pt12} flex1 flexColumn justifyContentCenter alignItemsCenter`}
          >
            <img
              src={`data:image/png;base64,${data?.qr}`}
              alt="QRCode"
              style={{ width: 170 }}
            />
            <Element
              className={`${classes.pt4} fw600 pt1`}
              style={{ color: '#9C9C9C' }}
            >
              <Translate value="cartAndOrders.transferInformation.scanCode" />
            </Element>
          </div>
        </div>
      </>
    )
  }
  const renderContentUSD = () => {
    return (
      <>
        <div className={classes.input}>
          <Input
            isShowLabel
            isShowIcon={false}
            placeHolder="cartAndOrders.transferInformation.bank"
            disabled
            value={formatText(data?.bank)}
            style={{ color: '#B5B5B5' }}
          />
        </div>
        <div className={classes.input}>
          <Input
            isShowLabel
            isShowIcon={false}
            placeHolder="cartAndOrders.transferInformation.accountHolder"
            disabled
            value={formatText(data?.accountHolder)}
            style={{ color: '#B5B5B5' }}
          />
        </div>
        <div className={classes.input}>
          <Input
            isShowLabel
            isShowIcon={true}
            placeHolder="cartAndOrders.transferInformation.accountNumber"
            disabled
            value={formatText(data?.accountNumber)}
            onClickIcon={onClickIcon}
            classIcon="icon-content-coppy"
            styleIcon={{ color: '#0553A5', fontSize: 16 }}
            style={{ color: '#9C9C9C' }}
          />
        </div>
        <div className={classes.input}>
          <Input
            isShowLabel
            isShowIcon={false}
            placeHolder="cartAndOrders.transferInformation.bankAddress"
            disabled
            value={formatText(data?.bankAddress)}
            style={{ color: '#B5B5B5' }}
          />
        </div>
        <div className={classes.input}>
          <Input
            isShowLabel
            isShowIcon={false}
            placeHolder="cartAndOrders.transferInformation.code"
            disabled
            value={formatText(data?.swiftCode)}
            style={{ color: '#B5B5B5' }}
          />
        </div>
        <div className={classes.input}>
          <Input
            isShowLabel
            isShowIcon
            placeHolder="cartAndOrders.transferInformation.amount"
            value={formatCurrencyFollowLocale(
              data?.amount,
              CURRENCY.USD,
              locale,
            )}
            onClickIcon={() => onClickIcon(data?.amount)}
            disabled
            classIcon="icon-content-coppy"
            style={{ color: '#B5B5B5' }}
            styleIcon={{ color: '#0553A5', fontSize: 16 }}
          />
        </div>
        <div className={classes.input}>
          <Input
            isShowLabel
            isShowIcon={true}
            placeHolder="cartAndOrders.transferInformation.message"
            disabled
            value={formatText(data?.message)}
            onClickIcon={onClickIcon}
            classIcon="icon-content-coppy"
            styleIcon={{ color: '#0553A5', fontSize: 16 }}
            style={{ color: '#9C9C9C' }}
          />
        </div>
      </>
    )
  }

  return (
    <PopupAction
      title="cartAndOrders.transferInformation.title"
      isShow={isShow}
      handleClose={handleClosePopup}
      btnSubmit={{
        label: 'cartAndOrders.transferInformation.ok',
        event: handleClosePopup,
        isI18n: true,
      }}
      appendStyle={{
        width: 580,
        padding: 20,
        backgroundColor: '#F3F3F3',
        borderRadius: '4px',
      }}
    >
      {type === TYPE_TRANSFER.VND && <>{renderContentVND()}</>}
      {type === TYPE_TRANSFER.USD && <>{renderContentUSD()}</>}
    </PopupAction>
  )
}
